import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, isDevMode } from '@angular/core';
import { Observable } from 'rxjs';
import { SetupResult, GetRegionsProvincesResult, SetupResultAlt, GetFileTypeResult, GetPossessionTitlesResult, GetCompanyTagsResult } from './bonus.models';

@Injectable()
export class BonusSharedService
{
    // constructor
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string)
    {

    }

    // get companies
    public getCompaniesByLoggedUser(): Observable<Array<SetupResult>>
    {
        return this.http.get<Array<SetupResult>>(`${this.baseUrl}api/admin/bonus/shared/getCompaniesByLoggedUser`);
    }

    // get file type
    public getFileType(fileTypeId: string): Observable<GetFileTypeResult>
    {
        return this.http.get<GetFileTypeResult>(`${this.baseUrl}api/admin/bonus/shared/getFileType/${fileTypeId}`);
    }

    // get file types
    public getFileTypes(): Observable<Array<GetFileTypeResult>>
    {
        return this.http.get<Array<GetFileTypeResult>>(`${this.baseUrl}api/admin/bonus/shared/getFileTypes`);
    }

    // get file groups
    public getFileGroups(): Observable<Array<SetupResult>>
    {
        return this.http.get<Array<SetupResult>>(`${this.baseUrl}api/admin/bonus/shared/getFileGroups`);
    }

    // get person types
    public getPersonTypes(): Observable<Array<SetupResultAlt>>
    {
        return this.http.get<Array<SetupResultAlt>>(`${this.baseUrl}api/admin/bonus/shared/getPersonTypes`);
    }

    // get beneficiary types
    public getBeneficiaryTypes(): Observable<Array<SetupResultAlt>>
    {
        return this.http.get<Array<SetupResultAlt>>(`${this.baseUrl}api/admin/bonus/shared/getBeneficiaryTypes`);
    }

    // get building types
    public getBuildingTypes(): Observable<Array<SetupResultAlt>>
    {
        return this.http.get<Array<SetupResultAlt>>(`${this.baseUrl}api/admin/bonus/shared/getBuildingTypes`);
    }

    // get possession titles
    public getPossessionTitles(): Observable<Array<GetPossessionTitlesResult>>
    {
        return this.http.get<Array<GetPossessionTitlesResult>>(`${this.baseUrl}api/admin/bonus/shared/getPossessionTitles`);
    }

    // get validation error types
    public getValidationErrorTypes(): Observable<Array<SetupResult>>
    {
        return this.http.get<Array<SetupResult>>(`${this.baseUrl}api/admin/bonus/shared/getValidationErrorTypes`);
    }

    // get regions
    public getRegions(): Observable<Array<GetRegionsProvincesResult>>
    {
        return this.http.get<Array<GetRegionsProvincesResult>>(`${this.baseUrl}api/admin/bonus/shared/getRegions`);
    }

    // get company tags
    public getCompanyTags(companyId: string): Observable<Array<GetCompanyTagsResult>>
    {
        return this.http.get<Array<GetCompanyTagsResult>>(`${this.baseUrl}api/admin/bonus/shared/getCompanyTags/${companyId}`);
    }

    // get provinces
    public getProvinces(regionIstatCode: string): Observable<Array<GetRegionsProvincesResult>>
    {
        return this.http.get<Array<GetRegionsProvincesResult>>(`${this.baseUrl}api/admin/bonus/shared/getProvinces/${regionIstatCode || ''}`);
    }

    // download attachment
    public downloadAttachment(fileId: string)
    {
        return this.http.get(this.baseUrl + 'api/admin/bonus/shared/download/' + fileId, { responseType: 'blob' });
    }

    // check is dev mode
    public isDevMode()
    {
        const _angularIsDev = isDevMode();
        const _applicationIsDev = location.origin.indexOf('bonusambientali-dev.azurewebsites.net') >= 0;

        return _angularIsDev || _applicationIsDev;
    }
}